import { useQuery } from "@tanstack/react-query";
import { apiRequest, getQueryFn, queryClient } from "@/lib/queryClient";
import type { User } from "@shared/schema";

export function useAuth() {
  // A signed-out visitor is the expected case on public pages, not an error.
  // Letting the default queryFn throw on 401 logged an uncaught error on every
  // landing-page view, which Lighthouse counts against Best Practices.
  const { data, isLoading } = useQuery<{ user: User } | null>({
    queryKey: ["/api/auth/user"],
    queryFn: getQueryFn<{ user: User } | null>({ on401: "returnNull" }),
    retry: false,
  });

  const user = data?.user;

  const logout = async () => {
    try {
      await apiRequest("POST", "/api/auth/logout", {});
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      queryClient.clear();
      window.location.href = "/login";
    }
  };

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    logout,
  };
}
